export default "__VITE_ASSET__DMadlqeL__"